var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-print-data white" },
    [
      _c(
        "div",
        { staticClass: "pa-8", attrs: { id: "print-content" } },
        [
          _c("p", { staticClass: "mt-3 mb-4" }, [
            _vm._v("Angaben zur Antragstellerin bzw. dem Antragsteller")
          ]),
          _c("applicant-information", {
            ref: "applicant-info",
            attrs: { readonly: "" }
          }),
          _c("p", { staticClass: "mt-6 mb-4" }, [_vm._v("Bankverbindung")]),
          _c("bank-details", { ref: "bank-details", attrs: { readonly: "" } }),
          _c("p", { staticClass: "mt-6 mb-0 mbb-4" }, [
            _vm._v("Angaben zur Förderberechtigung")
          ]),
          _c("funding-information", {
            ref: "funding-info",
            attrs: { readonly: "" }
          }),
          _c("p", { staticClass: "mt-6 mb-4" }, [
            _vm._v("Künstlerisches Konzept")
          ]),
          _c("artistic-concept", {
            ref: "artistic-concept",
            attrs: { readonly: "" }
          })
        ],
        1
      ),
      _c(
        "v-layout",
        { staticClass: "row btn-row px-8 py-4" },
        [
          _c(
            "v-flex",
            { staticClass: "xs6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.onPrint }
                },
                [_vm._v("Drucken")]
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { staticClass: "xs6 text-right" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: { color: "primary", outlined: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("Schließen")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }